import { render, staticRenderFns } from "./SalesAnalysis.vue?vue&type=template&id=65dbebe8&scoped=true"
import script from "./SalesAnalysis.vue?vue&type=script&lang=js"
export * from "./SalesAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SalesAnalysis.vue?vue&type=style&index=0&id=65dbebe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dbebe8",
  null
  
)

export default component.exports